import { defineMessage } from 'services/localization';

export const messages = {
    enableAutoApproval: defineMessage('enable_autoapproval'),
    description: defineMessage('requests_matching_the_d__automatically_approved'),
    hide: defineMessage('hide'),
    enable: defineMessage('enable'),
};
